import React, { useEffect, useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { DefaultTheme } from '../../Themes';
const StyledContainer = styled.div `
  cursor: pointer;
`;
const Collapsible = ({ isOpen = false, renderContent, theme = DefaultTheme, }) => {
    const [open, setOpen] = useState(isOpen);
    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen]);
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(StyledContainer, { onClick: () => setOpen(!open) }, renderContent(open))));
};
export default Collapsible;
